"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mobx = require("mobx");

var _class, _descriptor;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var BaseFilterModel = (_class = /*#__PURE__*/function () {
  function BaseFilterModel(definition) {
    _classCallCheck(this, BaseFilterModel);

    _initializerDefineProperty(this, "value", _descriptor, this);

    this.definition = definition;
    this.value = definition.defaultValue || "";
  }

  _createClass(BaseFilterModel, [{
    key: "updateValue",
    value: function updateValue(newValue) {
      this.value = newValue;
    }
  }, {
    key: "key",
    get: function get() {
      return "";
    }
  }, {
    key: "func",
    get: function get() {
      return function (rowData) {
        return true;
      };
    }
  }, {
    key: "type",
    get: function get() {
      return this.definition.type;
    }
  }, {
    key: "className",
    get: function get() {
      return this.definition.className;
    }
  }, {
    key: "columnName",
    get: function get() {
      return this.definition.columnSourceName;
    }
  }, {
    key: "defaultValue",
    get: function get() {
      return this.definition.defaultValue;
    }
  }, {
    key: "isNoOp",
    get: function get() {
      return this.definition.noopFilter;
    }
  }, {
    key: "placeholder",
    get: function get() {
      return this.definition.placeholder;
    }
  }]);

  return BaseFilterModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "value", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "updateValue", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateValue"), _class.prototype)), _class);
var _default = BaseFilterModel;
exports.default = _default;